import React, { useState } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { systemCode, urls } from '..';
import ResultsOverlay from '../common/ResultsOverlay';
import XRouterLink from '../common/seo/xrouter/XRouterLink';
import { getConfiguration } from '../data/utils/configuration';
import { parseIntFromString } from '../data/utils/parseIntFromString';
import { getLabel } from '../data/labels';
import { isPrematchBasePath } from '../common/seo/xrouter/seoUtils';

function ResultsLink() {
    const [toggled, setToggled] = useState(false);

    function toggle() {
        setToggled(!toggled);
    }

    return (
        <>
            <div className="xs_resultsLink ml-1 inline-flex shrink-0 items-center border border-cs7 rounded-md p-2" onClick={toggle}>
                <img src={`${process.env.PUBLIC_URL}/assets/images/results.svg`} alt="" />
                <span className="ml-1 font-medium text-xs text-cs-10">{getLabel('general.outcomes')}</span>
            </div>
            {toggled &&
                <ResultsOverlay toggle={toggle} />
            }
        </>
    );
}

export default function PrematchLinks() {
    const conf = getConfiguration();

    const params = useParams();
    let pathname = useLocation().pathname;
    if (pathname.endsWith('/')) {
        pathname = pathname.slice(0, -1);
    }
    const aggId = parseIntFromString(params.aggId);

    function urlJoin(...parts) {
        return parts
            .filter(p => p != null)
            .join('/')
            .replace(/\/\/+/g, '/');
    }

    let allBetsUrl = null;
    if (params.date != null) {
        allBetsUrl = urlJoin(urls.base, urls.prematch.base, urls.prematch.date, urls.prematch.allMatches, params.date, params.sportId, aggId);
    } else {
        allBetsUrl = urlJoin(urls.base, urls.prematch.base, urls.prematch.date, urls.prematch.today);
    }
    // allBetsUrl = allBetsUrl.replace(/\/\/+/g, '/');

    let urlFavoriteOdds;

    if (urls?.['favorite-odds']?.startsWith(`${urls.prematch.base}`) && isPrematchBasePath(window.location.pathname)) {
        urlFavoriteOdds = urls?.['favorite-odds'].replace(`${urls.prematch.base}/`, '')
    } else {
        urlFavoriteOdds = `${urls.base}/${urls.prematch.base}/${'quote-favorite'}`;
    }

    const location = useLocation();
    const isBetBuilderEnabled = conf.bbc?.en;
    const searchParams = new URLSearchParams(location.search);
    const isBetBuilderActive = searchParams.get('filter') === 'betbuilder';
    const separator = allBetsUrl.includes('?') ? '&' : '?';
    const betBuilderTargetUrl = `${allBetsUrl}${separator}filter=betbuilder`;



    return (
        <>
            <div className="xs_prematchLinks h-[48px] w-full overflow-x-auto px-2 flex items-center justify-between bg-cs1">
                <div className="inline-flex shrink-0 items-center border border-cs7 rounded-md p-2">
                    <img src={`${process.env.PUBLIC_URL}/assets/images/soccer-ball.svg`} alt="" />
                    <XRouterLink to={allBetsUrl} className="ml-1 font-medium text-xs text-cs-10">{getLabel('general.all_matches')}</XRouterLink>
                </div>
                {systemCode === 'SUREBET' &&
                    <div className="ml-1 inline-flex shrink-0 items-center border border-cs7 rounded-md p-2">
                        <img src={`${process.env.PUBLIC_URL}/assets/images/star.svg`} alt="" />
                        <XRouterLink to={`${urls.base}/${urls.prematch.base}/${urls.prematch.tournament}/top`} className="ml-1 font-medium text-xs text-cs-10">{getLabel('prematch.top_tournaments', 'Top leagues')}</XRouterLink>
                    </div>
                }
                {conf.foc?.enb &&
                    <div className="ml-1 inline-flex shrink-0 items-center border border-cs7 rounded-md p-2">
                        <img src={`${process.env.PUBLIC_URL}/assets/images/star.svg`} alt="" />
                        <XRouterLink to={urlFavoriteOdds} className="ml-1 font-medium text-xs text-cs-10">{getLabel('favorite_odds')}</XRouterLink>
                    </div>
                }
                {conf.tme === true &&
                    <div className="ml-1 inline-flex shrink-0 items-center border border-cs7 rounded-md p-2">
                        <img src={`${process.env.PUBLIC_URL}/assets/images/trophy.svg`} alt="" />
                        <XRouterLink to={`${urls.base}/${urls.prematch.base}/top-match`} className="ml-1 font-medium text-xs text-cs-10">{getLabel('prematch.top_matches')}</XRouterLink>
                    </div>
                }

                {isBetBuilderEnabled &&
                    <NavLink
                        to={betBuilderTargetUrl}
                        className="navLinks__wrapper !ml-1 inline-flex shrink-0 items-center border border-cs7 rounded-md p-2">
                        <img className={`betbuilder-icon h-[17px] ${isBetBuilderActive ? "active" : ''}`} src={`${process.env.PUBLIC_URL}/assets/images/bet-builder.svg`} alt="" />
                        <span
                            className={`ml-1 font-medium text-xs flex items-center gap-1 ${isBetBuilderActive ? 'text-cs-selected' : 'text-cs-10'}`
                            }>
                            {getLabel('betbuilder.title')}
                            <i className="icon-betbuilder-badge"></i>
                        </span>
                    </NavLink>
                }
                <ResultsLink />
            </div>


        </>
    );
}
